/* Ilinca & Elena - cart drawer: totals summary + upsell add */
(function () {
  function cartData() {
    var el = document.querySelector('#CartDrawer [data-products] .cart__items');
    return el ? el.dataset : null;
  }

  function sync() {
    var d = cartData();
    var box = document.getElementById('RlCartSummary');
    if (!d || !box) return;
    var has = d.rlHasSavings === '1';
    var save = box.querySelector('[data-rl-save]');
    var saveRow = box.querySelector('[data-rl-save-row]');
    var cmp = box.querySelector('[data-rl-compare]');
    var tot = box.querySelector('[data-rl-total]');
    if (tot && d.rlTotal) tot.textContent = d.rlTotal;
    if (cmp) { if (d.rlCompare) cmp.textContent = d.rlCompare; cmp.hidden = !has; }
    if (save && d.rlSavings) save.textContent = '-' + d.rlSavings;
    if (saveRow) saveRow.hidden = !has;
  }

  function init() {
    var target = document.querySelector('#CartDrawer [data-products]');
    if (!target || target.dataset.rlObserved) return;
    target.dataset.rlObserved = '1';
    new MutationObserver(sync).observe(target, { childList: true, subtree: true });
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-rl-upsell-add]') : null;
    if (!btn) return;
    e.preventDefault();
    var item = btn.closest('.rl-upsell__item');
    var sel = item ? item.querySelector('.rl-upsell__variant') : null;
    var id = sel ? sel.value : null;
    if (!id) return;

    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';

    var products = document.querySelector('#CartDrawer [data-products]');
    var changed = false;
    var mo = products ? new MutationObserver(function () { changed = true; }) : null;
    if (mo) mo.observe(products, { childList: true, subtree: true });

    var addUrl = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        var product = res && res.items ? res.items[0] : res;
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: product } }));
        setTimeout(function () {
          if (mo) mo.disconnect();
          if (!changed) window.location.reload();
        }, 1500);
      })
      .catch(function () {
        if (mo) mo.disconnect();
        btn.disabled = false;
        btn.textContent = label;
      });
  });
})();
